<template>
    <div @click="loginLinkClicked" class="login-link">
        <p class="block leading-none m-0" v-html="label"></p>
    </div>
</template>

<script>
import { CSPageEvents } from '@/helpers/GAHelpers';

export default {
    name: 'LogInLink',
    props: {
        customStyle: {
            type: Object,
        },
    },
    computed: {
        isUserLoggedIn: {
            get() {
                return this.$store.getters['auth/isUserLoggedIn'];
            },
        },
        label() {
            return this.isUserLoggedIn ? this.$t('LOGIN_LINK_LOG_OUT') : this.$t('LOGIN_LINK_LOG_IN');
        },
        url() {
            return this.isUserLoggedIn ? '/logout' : '/login';
        },
    },
    methods: {
        loginLinkClicked() {
            if (this.isUserLoggedIn) {
                this.$router.push({ name: 'logout' });
                CSPageEvents(undefined, { userLogged: 'Logged-out' });
            } else {
                this.$router.push({ name: 'login' });
            }
        },
    },
};
</script>

<style scoped>
    .login-link {
        cursor: pointer;
    }
    .login-link:hover {
        opacity: 0.5;
    }
</style>
